import React from "react";
import { useTheme } from "../ThemeProvider";
import "./embed.css";
import Header from "../components/header/mainHeader.js";
import Footer from "../components/footer/mainFooter.js";
import SingleUsecaseCall from "../singleUsecase/singleUsecaseCall/singleUsecaseCall.js";
import SingleUsecaseHero from "../singleUsecase/singleUsecaseHero/singleUsecaseHero.js";
import SingleUsecaseDescription from "../singleUsecase/singleUsecaseDescription/singleUsecaseDescription.js";
import SingleUsecasePhoto from "../singleUsecase/singleUsecasePhoto/singleUsecasePhoto.js";

import a from "../assets/maya/01.webp";
import b from "../assets/maya/02.webp";
import c from "../assets/maya/03.webp";
import d from "../assets/maya/04.webp";
import e from "../assets/maya/05.webp";

function TheOnlyMaya() {
  const { theme } = useTheme();

  document.title = "3VO | The Only Maya";

  return (
    <div className={`subpage ${theme === "light" ? "" : "dark-theme"}`}>
      <Header />
      <SingleUsecaseHero title="The Only Maya" subtitle="" />
      <SingleUsecasePhoto img={a} name="The Only Maya" />
      <SingleUsecasePhoto img={b} name="The Only Maya" />
      <SingleUsecasePhoto img={c} name="The Only Maya" />
      <SingleUsecasePhoto img={d} name="The Only Maya" />
      <SingleUsecasePhoto img={e} name="The Only Maya" />
      <SingleUsecaseCall />
      <Footer />
    </div>
  );
}

export default TheOnlyMaya;
